<template>
  <ElTooltip
    class="box-item"
    effect="light"
    :content="props.description"
    :placement="props.location">
    <MiIcon icon="TOOLTIP" />
  </ElTooltip>
</template>

<script lang="ts">
export default {
  name: 'Tooltip',
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script lang="ts" setup>
import { Placement } from 'element-plus';

import { MiIcon } from '~shared/ui';

type Props = {
  description: string;
  location?: Placement;
};

const props = withDefaults(defineProps<Props>(), {
  description: '',
  location: 'top-start',
});
</script>

<style lang="scss" scoped></style>
